/*
  Note: utils-role-check file contains utility functions which helps in identifying
  whether the logged in user has certain roles.
*/


/**
 * Checks whether the given role type exists in corporate user roles.
 * @param userData - Details of the logged in user.
 * @param roleType - Type of the role.
 * @returns [Boolean] - Whether the given role type exists in the user roles.
 */
export function doesCorporateUserContainRole(userData, roleType) {
  // Checks if the user has the given role in the corporate profile.
  return checkRole(userData.corporateProfileRoles, roleType);
}

/**
 * Checks whether the given role type exists in party user roles.
 * @param userData - Details of the logged in user.
 * @param roleType - Type of the role.
 * @returns [Boolean] - Whether the given role type exists in the user roles.
 */
export function doesPartyUserContainRole(userData, roleType) {
  // Checks if the user has the given role in the corporate profile.
  return checkRole(userData.partyProfileRoles, roleType);
}

/**
 * For a given list of roles, checks if a given role type exists.
 * @param rolesList - List of Roles.
 * @param roleToCheck - Role Type to check.
 */
export function checkRole(rolesList, roleToCheck) {
  return rolesList.some(role => role.role_type === roleToCheck);
}
